import { getPaletteColor } from "theme/helpers";
import { TStyles } from "utils/Styles";

const styles = {
  errorContainer: {
    minHeight: "100%",
    flexShrink: 0,
    backgroundColor: getPaletteColor("grey.100"),
    p: 6,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    gap: 2,
  },
} satisfies TStyles;

export default styles;
